// src/components/hero/index.js
import { connect } from 'react-redux'
import {
  getViewportWidth,
  getViewportHeight,
  getPreventScroll
} from '../app/selectors'
import { 
  getSlides, 
  getHeroInViewport,
  getHeroFetching } from './selectors'
import { getLogoActive } from '../logo/selectors'
import { fetchHero } from './actions'
import Hero from './hero'

const mapStateToProps = state => {
  return {
    vw: getViewportWidth(state),
    vh: getViewportHeight(state),
    inViewport: getHeroInViewport(state),
    slides: getSlides(state),
    fetching: getHeroFetching(state),
    logoActive: getLogoActive(state),
    preventScroll: getPreventScroll(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onStartup: () => {
      dispatch(fetchHero())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Hero)



// WEBPACK FOOTER //
// ./src/components/hero/index.js